var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"pannablePlayer",staticClass:"the-video-player-container-inner",style:({
    cursor: _vm.cursor,
    width: _vm.playerWidth + 'px',
    height: _vm.playerHeight + 'px',
  }),on:{"touchend":_vm.checkTouchEnd,"&touchmove":function($event){_vm.hasDragged = true},"mousedown":function($event){return _vm.startTimer()},"mouseup":_vm.checkTimer}},[_c('video',{ref:"videoPlayer0",staticClass:"video-js player-0",attrs:{"crossOrigin":"anonymous"}}),_c('video',{ref:"videoPlayer1",staticClass:"video-js player-1",attrs:{"crossOrigin":"anonymous"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }